// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import key02Icon from "@/assets/icons/key-02.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Key02IconProps = Omit<IconProps, "name">;

export function Key02Icon(props: Key02IconProps): React.ReactNode {
  return <Icon name={key02Icon} {...props} />;
}
